
import { Vue, Options, prop } from "vue-class-component";

class Props {
  printed = prop<boolean>({ type: Boolean, default: false });
}

@Options({})
export default class PrintStatusIcon extends Vue.with(Props) {}
